export const INITIAL_COUNTRIES_SEARCH_PARAMS = {
  page: 1,
  name: '',
  id: '',
  iso_code_2: '',
  iso_code_3: '',
  sort_method: 'desc',
  order_by: 'id',
}

export const INITIAL_COUNTRY = {
  id: null,
  iso_code_2: '',
  iso_code_3: '',
  code: '',
  status: 0,
  sort_order: 20,
  descriptions: [],
}

export const INITIAL_DESCRIPTIONS = [
  {
    name: '',
    language_id: 1,
  },
  {
    name: '',
    language_id: 2,
  },
]
